import * as React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
var queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});
export var QueryProvider = function QueryProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, children);
};
export default QueryProvider;